import React, { useEffect } from "react";
import { Navbar, NavbarBrand, NavbarText } from "reactstrap";
import { connect } from "react-redux";

import { getConstants } from "../../../reduxStore/actions/serverConstants";

import FullLogo from "./../../../assets/images/web-logo_n.png";
import Label from "./../../../components/label";

const TopNav = props => {
  useEffect(() => {
    props.getConstants();
  }, []);

  return (
    <Navbar fixed="top" color="light" light expand="md" className="top-nav row">
      <NavbarBrand href="/" className="col-sm-2 offset-sm-1 pl-3">
        <img src={FullLogo} alt="Instant Consult Logo" className="full-logo" />
      </NavbarBrand>
      <NavbarText className="col-sm-8 d-flex flex-row justify-content-end align-items-center">
        <Label title="Support" className="mr-3 mb-0 support-label" />
        <i className="fas fa-phone-alt pr-2"></i>
        <a
          href={
            props.serverConstants
              ? "tel:" + props.serverConstants.phoneNumber
              : ""
          }
          className="insta-link-orange mr-3 thin-font"
        >
          {props.serverConstants && props.serverConstants.phoneNumber
            ? props.serverConstants.phoneNumber.slice(0, 4) +
              " " +
              props.serverConstants.phoneNumber.slice(4, 7) +
              " " +
              props.serverConstants.phoneNumber.slice(7, 10)
            : ""}
        </a>
        <div className="w-100 d-block d-sm-none"></div>
        <i className="fas fa-envelope ml-3 pr-2"></i>
        <a
          href={
            props.serverConstants ? "mailto:" + props.serverConstants.email : ""
          }
          className="insta-link-orange thin-font"
        >
          {props.serverConstants ? props.serverConstants.email : ""}
        </a>
      </NavbarText>
    </Navbar>
  );
};

const mapStateToProps = state => ({
  serverConstants: state.serverConstants.constants
});

const mapDispatchToProps = dispatch => ({
  getConstants: () => dispatch(getConstants())
});

export default connect(mapStateToProps, mapDispatchToProps)(TopNav);
